const sidebarCategoriesList = document.querySelector(".js-sidebar-categories-list");

if (sidebarCategoriesList) {
    window.addEventListener("load", () => initSidebarCategories(sidebarCategoriesList));
}

const initSidebarCategories = (list) => {
    if (list.offsetHeight <= 106) return;

    const items = list.children;

    for (let i = items.length - 1; i >= 0; i--) {
        items[i].classList.add("hidden");

        if (list.offsetHeight <= 106) {
            items[i - 1].classList.add("hidden");

            break;
        }
    }

    const btn = document.createElement("button");

    btn.classList.add("tag-item", "tag-item--more");
    btn.type = "button";
    btn.textContent = "Ещё";

    btn.addEventListener("click", () => {
        for (let i = items.length - 1; i >= 0; i--) {
            items[i].classList.remove("hidden");
        }

        btn.remove();
    });

    list.appendChild(btn);
};
